"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockKitProduct = void 0;
const __1 = require("../");
function mockKitProduct(overrides = {}) {
    return {
        active: true,
        id: 1,
        product: (0, __1.mockProduct)(),
        quantity: 1,
        ...overrides,
    };
}
exports.mockKitProduct = mockKitProduct;
